var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`template-section template-section-${_vm.type ? _vm.type : ''}`},[_c('img',{attrs:{"src":_vm.image && _vm.image.file && _vm.image.file.file_path,"alt":"template image","width":"100%","height":"100%"}}),_vm._l((_vm.content),function(item,index){return _c('div',{key:index,class:`template-content-section flex index-${index}`,style:({
      ...item.style,
      fontSize: _vm.getStyleValue(item.style.fontSize, _vm.rate.x),
      width: `${
        item.style.width ? _vm.getStyleValue(item.style.width, _vm.rate.x) : 'auto'
      }`,
      height: `${
        item.style.height ? _vm.getStyleValue(item.style.height, _vm.rate.y) : 'auto'
      }`,
      top: `${item.style.top ? _vm.getStyleValue(item.style.top, _vm.rate.y) : 0}`,
      left: `${item.style.left ? _vm.getStyleValue(item.style.left, _vm.rate.x) : 0}`
    })},[_c('p',{domProps:{"innerHTML":_vm._s(item.content)}})])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }